export default "/themes/nutristopa/assets/img/arrow.png";